import { render, staticRenderFns } from "./TimelineTab.vue?vue&type=template&id=65dcea10&scoped=true"
import script from "./TimelineTab.vue?vue&type=script&lang=ts"
export * from "./TimelineTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65dcea10",
  null
  
)

export default component.exports